import './index.css'

const Whychooseus = () => {
  return(
    <div className='why-choose-us-container'>
        <h1 className='why-choose-us-heading'>Why Choose Navnidhi Special School?</h1>
        <ul className='list-container'>
            <li className='list-item'> Experienced & Trained Special Educators</li>
            <li className='list-item'> Individual Attention for Every Child</li>
            <li className='list-item'> Integrated Therapy Services</li>
            <li className='list-item'> Safe & Secure Environment</li>
            <li className='list-item'> Parent Counseling & Support</li>
            <li className='list-item'> Modern Learning Infrastructure</li>
        </ul>

    </div>
  )
}
export default Whychooseus